// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"7ff92100","219":"cc39d0d1","266":"97ad089b","848":"843bccc4"}[chunkId] + ".chunk.js";
};